import React from 'react';
import ReactDOM from 'react-dom/client';
//
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// css
import 'simplebar/src/simplebar.css';
import 'react-toastify/dist/ReactToastify.css';
// import 'maplibre-gl/dist/maplibre-gl.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-image-lightbox/style.css';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'react-auth-kit';
import { toast } from 'react-toastify';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import refreshApi from './api/refreshApi';
import { SocketProvider } from './contexts/SocketContext';

// Create a client
const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: (error) => {
			toast.error(
				<div>
					<div style={{ fontWeight: 'bold' }}>Something went wrong</div>
					<br />
					{error}
				</div>
			);
		},
	}),
	mutationCache: new MutationCache({
		onError: (error) => {
			toast.error(
				<div>
					<div style={{ fontWeight: 'bold' }}>Something went wrong</div>
					<br />
					{error}
				</div>
			);
		},
	}),
	defaultOptions: {
		queries: {
			retry: false,
			refetchOnWindowFocus: false,
		},
		mutations: {
			retry: false,
			retryDelay: 0,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<SocketProvider>
			<HelmetProvider>
				<QueryClientProvider client={queryClient}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<AuthProvider
							authType={'cookie'}
							authName={'_auth'}
							refresh={refreshApi}
							cookieDomain={window.location.hostname}
							cookieSecure={window.location.protocol === 'https:'}
						>
							<BrowserRouter>
								<App />
							</BrowserRouter>
						</AuthProvider>
					</LocalizationProvider>
				</QueryClientProvider>
			</HelmetProvider>
		</SocketProvider>
	</React.StrictMode>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
